export const ONBOARDING_STORAGE_KEY = "demo_onboarding_journey";
export const DEMO_PROGRESS_STORAGE_KEY = "demo_feature_progress";

export function loadOnboardingJourney() {
  try {
    const raw = localStorage.getItem(ONBOARDING_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

export function saveOnboardingJourney(value) {
  localStorage.setItem(ONBOARDING_STORAGE_KEY, JSON.stringify(value));
}

export function clearOnboardingJourney() {
  localStorage.removeItem(ONBOARDING_STORAGE_KEY);
}

export function buildOnboardingSteps(selected = []) {
  const set = new Set(selected);
  const steps = [];

  if (set.has("shopify")) {
    steps.push({ id: "shopify_integration", path: "/integrations/shopify", label: "Connect Shopify" });
    steps.push({ id: "shopify_settings", path: "/settings/shopify", label: "Configure Shopify settings" });
  }
  if (set.has("ebay")) {
    steps.push({ id: "ebay_integration", path: "/integrations/ebay", label: "Connect eBay" });
    steps.push({ id: "ebay_settings", path: "/settings/ebay", label: "Configure eBay settings" });
  }
  if (set.has("poshmark") || set.has("vinted")) {
    steps.push({ id: "social_integration", path: "/integrations/poshmark", label: "Connect Poshmark/Vinted" });
  }

  steps.push({ id: "general_settings", path: "/settings/general", label: "General settings" });
  return steps;
}
